/**
 * SubtaskProgressBar Component
 * Displays visual progress indicator for subtask completion
 */
import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { COLORS } from '../../shared/colors';

const SubtaskProgressBar = ({ subtasks = [], hideText = false }) => {
  if (!subtasks || subtasks.length === 0) return null;

  const completedCount = subtasks.filter(
    subtask => subtask.marked_as_completed || subtask.completed || subtask.is_completed
  ).length;
  const totalCount = subtasks.length;
  const percentage = Math.round((completedCount / totalCount) * 100);

  return (
    <Box sx={{ mb: hideText ? 0 : 2, width: '100%' }}>
      {!hideText && (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Typography variant="caption" fontWeight="600" color="text.secondary">
            Subtask Progress
          </Typography>
          <Typography variant="caption" fontWeight="600" sx={{ color: COLORS.primary }}>
            {completedCount}/{totalCount} ({percentage}%)
          </Typography>
        </Box>
      )}
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: 8,
          borderRadius: 4,
          bgcolor: COLORS.subtask.progressUnfilled,
          '& .MuiLinearProgress-bar': {
            bgcolor: percentage === 100 ? COLORS.success : COLORS.subtask.progressFilled,
            borderRadius: 4,
            transition: 'all 0.3s ease-in-out'
          }
        }}
      />
    </Box>
  );
};

export default SubtaskProgressBar;
